var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"1080px","background-color":"grey"}},[_c('hero-section'),_c('vision-section'),_c('about-section'),_c('project-section'),_c('contact-section'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }